import React, { useState, useEffect, useRef, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import LandingNav from "../Landing_Nav";
import group9 from "../../../images/LandingPageImage/blue_theme 1.png";
import google from "../../../images/LandingPageImage/google.png";
import ThreeCardsSection from "./ThreeCardsSection";
import SecondScroll from "./SecondScroll";
import FifthSection from "./FifthSection";
import ForthSection from "./ForthSection";
import LandingFooter from "../Landing_Footer";
import FaQ from "./FaQ";
import PricingSection from "./PricingSection";
import CtaSection from "./CtaSection";
import MyContext from "../../../MyContext";
import GoogleOneTap from "../../GoogleOneTapnew";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const slideData = {
  id: 1,
  subtitle:
    "Send messages, automate replies, manage chats, and run campaigns easily—all from one simple and powerful WhatsApp workspace designed to help your business grow.",
  image: group9,
  ctaPrimary: "Start Free Trial",
  ctaSecondary: "Start Free Trial",
};

const AutoScrollHero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [imageScale, setImageScale] = useState(0.8);
  const imageRef = useRef(null);
  const navigate = useNavigate();
   const location = useLocation();
  const { openFreeTrialModal } = useContext(MyContext);
  const hasAutoOpened = useRef(false);

 

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("accessToken");

    if (!isLoggedIn && !hasAutoOpened.current) {
      hasAutoOpened.current = true;

      const timer = setTimeout(() => {
        openFreeTrialModal();
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [openFreeTrialModal]);

  useEffect(() => {
    const handleScroll = () => {
      if (imageRef.current) {
        const rect = imageRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Calculate how much of the image is visible
        const visiblePercentage = Math.max(
          0,
          Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height))
        );

        // Scale from 0.8 to 1.1 based on scroll
        const scale = 0.8 + visiblePercentage * 0.4;
        setImageScale(Math.min(scale, 1));
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial call

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const pageKey = location.pathname;
    const storageKey = `freeTrialClosed_${pageKey}`;
  
    if (!sessionStorage.getItem(storageKey)) {
      openFreeTrialModal(pageKey);
    }
  
    return () => {
      sessionStorage.removeItem(storageKey);
    };
  }, [location.pathname]);
  
  const slide = slideData;

  return (
    <>
      <style>{`
        :root {
          --hero-bg-1: #1E1B4B;
          --hero-bg-2: #2F2CD8;
          --hero-title-color: #ffffff;
          --hero-sub-color: #e6e6e6;
          --btn-bg-color: #4B63FF;
          --btn-text-color: #ffffff;
          --btn-bg-hover: #2F2CD8;
          --btn-text-hover: #ffffff;
          --max-width: 1600px;
          --nav-padding-desktop: 5rem;
          --nav-padding-xl: 4rem;
          --nav-padding-lg: 3rem;
          --nav-padding-md: 2rem;
          --nav-padding-sm: 1.25rem;
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          overflow-x: hidden;
        }

        .hero-section {
          width: 100%;
          background: linear-gradient(135deg, var(--hero-bg-1), var(--hero-bg-2));
          padding: 1rem 0 0 0;
          position: relative;
          overflow: hidden;
          min-height: 70vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .hero-container {
          width: 100%;
          max-width: var(--max-width);
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          padding-left: var(--nav-padding-desktop);
          padding-right: var(--nav-padding-desktop);
          align-items: center;
          gap: 3rem;
        }

        .hero-top {
          width: 100%;
          max-width: 800px;
          z-index: 3;
          text-align: center;
          padding-top: 2rem;
        }

        .hero-title {
          font-size: 3rem;
          font-weight: 700;
          line-height: 1.15;
          color: var(--hero-title-color);
          margin: 0;
          opacity: 0;
          transform: translateY(-50px);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1), transform 900ms cubic-bezier(.2,.9,.2,1);
        }

        .hero-title.visible { 
          opacity: 1; 
          transform: translateY(0); 
        }

        .hero-sub {
          margin-top: 1.5rem;
          font-size: 1.15rem;
          color: var(--hero-sub-color);
          line-height: 1.6;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          opacity: 0;
          transform: translateY(-30px);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 150ms, transform 900ms cubic-bezier(.2,.9,.2,1) 150ms;
        }

        .hero-sub.visible { 
          opacity: 1; 
          transform: translateY(0); 
        }

        .hero-ctas {
          margin-top: 2rem;
          display: flex;
          gap: 1rem;
          justify-content: center;
          flex-wrap: wrap;
          opacity: 0;
          transform: translateY(-20px);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 300ms, transform 900ms cubic-bezier(.2,.9,.2,1) 300ms;
        }

        .hero-ctas.visible { 
          opacity: 1; 
          transform: translateY(0); 
        }

        .btn-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.85rem 2rem;
          font-size: 1.05rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          background: var(--btn-bg-color);
          color: var(--btn-text-color);
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-primary:hover {
          background: var(--btn-bg-hover);
          color: var(--btn-text-hover);
          transform: translateY(-3px);
        }

        .btn-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 28px;
          padding: 0.6rem 1.2rem;
          font-weight: 700;
          cursor: pointer;
          border: none;
          outline: none;
          white-space: nowrap;
          background: var(--btn-bg-color);
          color: var(--btn-text-color);
          transition: background 200ms ease, color 200ms ease, transform 150ms ease;
        }

        .btn-secondary:hover,
        .btn-secondary:focus {
          background: var(--btn-bg-hover);
          color: var(--btn-text-hover);
          transform: translateY(-3px);
        }

        .hero-bottom {
          width: 100%;
          max-width: 900px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          z-index: 1;
          padding: 0 1rem;
        }

        .hero-image-wrapper {
          width: 100%;
          max-width: 1000px;
          position: relative;
          overflow: hidden;
          border-radius: 20px;
          opacity: 0;
          transform: translateY(90px);
          transition: opacity 900ms cubic-bezier(.2,.9,.2,1) 200ms, transform 900ms cubic-bezier(.2,.9,.2,1) 200ms;
        }

        .hero-image-wrapper.visible {
          opacity: 1;
          transform: translateY(20px);
        }

        .hero-image {
          width: 100%;
          height: auto;
          display: block;
          transition: transform 300ms cubic-bezier(.2,.9,.2,1);
          will-change: transform;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: radial-gradient(800px 400px at 50% 30%, transparent 60%);
          z-index: 2;
        }

       .hero-circles {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          height: 400px;
          pointer-events: none;
          z-index: 1;
          overflow: visible;
        }

        .circle {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          border-radius: 50%;
          border: 0.25px solid #ffffff;
          opacity: 0.2;
        }

        .circle-1 {
          width: 1470px;
          height: 1470px;
          bottom: -900px;
        }

          /* Inner circle */
          .circle-2 {
            width: 1200px;
            height: 1200px;
            bottom: -800px;
          }

                @media (max-width: 992px) {
            .circle-1 {
              width: 900px;
              height: 900px;
              bottom: -600px;
            }

              .circle-2 {
                width: 750px;
                height: 750px;
                bottom: -500px;
              }
            }

            @media (max-width: 576px) {
              .circle-1 {
                width: 650px;
                height: 650px;
                bottom: -450px;
              }

              .circle-2 {
                width: 420px;
                height: 420px;
                bottom: -280px;
              }
            }

        /* Tablet */
        @media (max-width: 1200px) {
          .hero-container {
            padding-left: var(--nav-padding-lg);
            padding-right: var(--nav-padding-lg);
          }
          
          .hero-title {
            font-size: 3rem;
          }
          
          .hero-sub {
            font-size: 1.1rem;
          }
          .hero-image-wrapper.visible {
            opacity: 1;
            transform: translateY(10px);
          }
          .hero-section {
            min-height: auto;
          }
        }

        @media (max-width: 992px) {
          .hero-container {
            padding-left: var(--nav-padding-md);
            padding-right: var(--nav-padding-md);
          }
          
          .hero-title {
            font-size: 2.5rem;
          }
          
          .hero-sub {
            font-size: 1.05rem;
            max-width: 600px;
          }
            .hero-image-wrapper.visible {
              opacity: 1;
              transform: translateY(10px);
          }
            .hero-section {
              min-height: auto;
          }
        }

        /* Mobile */
        @media (max-width: 768px) {
          .hero-section {
            min-height: auto;
          }

          .hero-container {
            padding-left: var(--nav-padding-sm);
            padding-right: var(--nav-padding-sm);
            gap: 2rem;
          }
          
          .hero-top {
            padding-top: 1rem;
          }
          
          .hero-title {
            font-size: 2rem;
            line-height: 1.2;
          }
          
          .hero-sub {
            font-size: 1rem;
            margin-top: 1rem;
            line-height: 1.5;
          }
          
          .hero-ctas {
            margin-top: 1.5rem;
            gap: 0.75rem;
          }
          
          .btn-primary {
            padding: 0.75rem 1.5rem;
            font-size: 1rem;
          }

          .hero-image-wrapper {
            border-radius: 12px;
            max-width: 100%;
          }
        }

        @media (max-width: 480px) {
          .hero-title {
            font-size: 1.75rem;
          }
          
          .hero-sub {
            font-size: 0.95rem;
          }
          
          .btn-primary {
            padding: 0.7rem 1.3rem;
            font-size: 0.95rem;
          }
        }
      `}</style>

      <section className="hero-section" aria-label="Dhroom hero section">
        <div className="hero-circles">
          <div className="circle circle-1"></div>
          <div className="circle circle-2"></div>
        </div>

        <div className="hero-container">
          <div className="hero-top">
            <h1 className={`hero-title ${isVisible ? "visible" : ""}`}>
              <span style={{ color: "var(--btn-bg-color)" }}>
                Powerful WhatsApp
              </span>
              <br />
              Automation Made Simple
            </h1>

            <p className={`hero-sub ${isVisible ? "visible" : ""}`}>
              {slide.subtitle}
            </p>

            <div className={`hero-ctas ${isVisible ? "visible" : ""}`}>
              <button
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={() => navigate("/login?provider=google")}
              >
                <span>Continue with</span>
                <img
                  src={google}
                  alt="Google"
                  style={{ width: "28px", height: "28px" }}
                />
              </button>

              <button onClick={openFreeTrialModal} className="btn-secondary">
                {slide.ctaPrimary}
              </button>
            </div>
          </div>

          <div className="hero-bottom">
            <div
              ref={imageRef}
              className={`hero-image-wrapper ${isVisible ? "visible" : ""}`}
            >
              <img
                src={slide.image}
                alt="WhatsApp Automation Platform Illustration"
                className="hero-image"
                style={{ transform: `scale(${imageScale})` }}
                loading="lazy"
              />
              <div className="hero-overlay" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Home = ({ country, handleCountryChange }) => {
    const { baseUrl } = useContext(MyContext)
  const [pageData, setPageData] = useState(null);

  const fetchSeoData = async () => {
    try {
      const response = await fetch("/seo.json");
      const data = await response.json();
      if (data.status === "0" && Array.isArray(data.data)) {
        const pages = data.data[0]?.pages || [];
        const faqPageData = pages.find((page) => page.page_id === "52");
        if (faqPageData) setPageData(faqPageData);
      }
    } catch (error) {
      console.error("Error fetching SEO data:", error);
    }
  };

  useEffect(() => {
    fetchSeoData();
  }, []);

  const registerUserAfterGoogleLogin = async (googleUser) => {
    // console.log(" register API CALLED", googleUser);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append(
      "Authorization",
      "Basic YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU="
    );

    const payload = {
      userid: "1",
      clientName: googleUser.email,
      password: googleUser.email,
      clientNumber: googleUser.email,
      userType: "1",
      onboardingType: "2",
      onboardedBy: "1",
      clientId: "1",
      billingName: googleUser.name,
      allowedIp: "",
      firstName: googleUser.firstName,
      lastName: googleUser.lastName,
    };

    // console.log(" REGISTER PAYLOAD", payload);

    const response = await fetch(`${baseUrl}/api/User/register`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
    });

    // console.log(" HTTP STATUS:", response.status);

    const result = await response.json();
    // console.log(" REGISTER API RESPONSE:", result);

    return result;
  };

  const handleGoogleResponse = async (response) => {
    try {
      if (!response?.credential) return;

      const base64Url = response.credential.split(".")[1];
      const decodedData = JSON.parse(
        atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"))
      );

      const googleUser = {
        name: decodedData.name,
        email: decodedData.email,
      };

      const registerResult = await registerUserAfterGoogleLogin(googleUser);

      if (registerResult?.responseCode !== "00") {
        toast.error(registerResult?.responseMessage || "Registration failed");
        return;
      }

      sessionStorage.setItem("user", JSON.stringify(registerResult.response));

      sessionStorage.setItem("power", "1");

      toast.success("Login successful");

      setTimeout(() => {
        window.location.href = "/Dashboard";
      }, 1500);
    } catch (err) {
      console.error("GOOGLE LOGIN ERROR", err);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Helmet>
        <title>Dhroom - WhatsApp Automation for Businesses</title>
        <link rel="preload" href={group9} as="image" />
      </Helmet>

      <div className="d-flex justify-content-center">
        <ToastContainer />
      </div>

      <LandingNav country={country} handleCountryChange={handleCountryChange} />

      <AutoScrollHero />

      <SecondScroll />
      <ThreeCardsSection />
      <ForthSection />
      <FifthSection />
      <PricingSection />
      <FaQ />
      <CtaSection />
      <LandingFooter />
      {/* <GoogleOneTap onSuccess={handleGoogleResponse} /> */}

      {!sessionStorage.getItem("user") && (
        <GoogleOneTap onSuccess={handleGoogleResponse} />
      )}
    </>
  );
};

export default Home;
